export default __webpack_public_path__ + "static/media/eclipse6.996d267d.svg";